
<template>
  <div class="custom-multiselect-style placeholder-italic">
    <multiselect
      v-model="selectedOption"
      :options="availabilityOptions"
      placeholder="Assign priority"
      :searchable="false"
      :show-no-results="false"
      :openDirection="below"
      :taggable="false"
      :showLabels="false"
      :show-labels="false"
      @input="updateSelection"
      @change="updateSelection"
    >
    <template v-slot:option="{ option }">
        <div class="multiselect-option flex flex-row gap-2 justify-flex-start items-center">
         <template v-if="option === 'High'">
          <High class="w-6 h-6"/>
        </template>
        <template v-else-if="option === 'Highest'">
          <Highest />
        </template>
        <template v-else-if="option === 'Low'">
          <Low />
        </template>
        <template v-else-if="option === 'Lowest'">
          <Lowest />
        </template>
        <template v-else>
          <Medium />
        </template>
          <span>{{ option }}</span>
        </div>
      </template>
       <template v-slot:selected="{ option }">
        <div class="multiselect-option flex flex-row gap-2 justify-flex-start items-center">
         <template v-if="option === 'High'">
          <High class="w-6 h-6"/>
        </template>
        <template v-else-if="option === 'Highest'">
          <Highest />
        </template>
        <template v-else-if="option === 'Low'">
          <Low />
        </template>
        <template v-else-if="option === 'Lowest'">
          <Lowest />
        </template>
        <template v-else>
          <Medium />
        </template>
          <span>{{ option }}</span>
        </div>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Highest from "@/components/icons/PriorityIcons/Highest.vue";
import High from "@/components/icons/PriorityIcons/High.vue";
import Low from "@/components/icons/PriorityIcons/Low.vue";
import Lowest from "@/components/icons/PriorityIcons/Lowest.vue";
import Medium from "@/components/icons/PriorityIcons/Medium.vue";

export default {
  components: {
    Multiselect,
    Highest,
    High,
    Low,
    Lowest,
Medium

  },
  props: {
    value: {
      type: String,
      default: "Assign Priority",
    },
    placeholder: {
      type: String,
      default: "Assign Priority",
    },
  },

  data() {
    return {
      selectedOption: this.value,
      availabilityOptions: ["Highest", "High", "Medium", "Lowest",  "Low"],
    };
  },
  watch: {
    value(newValue) {
      this.selectedOption = newValue;
    },
  },
  methods: {
    updateSelection() {
      if (this.selectedOption !== null) {
        this.$emit("input", this.selectedOption);
      }
    },
    get placeholderText() {
      return this.placeholder ? this.placeholder : "Assign Priority";
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-multiselect-style
  .multiselect.multiselect--active
  .multiselect__select::before {
  top: -3% !important;
}
.custom-multiselect-style::v-deep .multiselect {
  &.multiselect--active {
    .multiselect__tags,
    .multiselect__content-wrapper {
      min-width: 280px;
      @apply border-primary;
    }
  }

  .multiselect__placeholder,
  .multiselect__input,
  .multiselect__single {
    display: block !important;
    // padding-top: 0.25rem !important;
    height: 100% !important;
    min-height: 24px !important;
    @apply text-low;
  }

  &.error {
    .multiselect__tags {
      border-color: rgba(248, 180, 180, 1) !important;
      box-shadow: 0 0 0 3px rgba(248, 180, 180, 0.45) !important;
    }
    .multiselect__placeholder {
      color: rgba(155, 28, 28, 1) !important;
    }
  }

  .multiselect__tags-wrap {
    margin-right: 35px;
    @apply flex flex-wrap;
  }

  .multiselect__input:focus::placeholder {
    color: #adadad !important;
  }

  .multiselect__option {
    font-size: 14px !important;
    span {
      text-transform: capitalize;
    }
  }

  .multiselect__option--highlight {
    &.multisecelt__option--selected {
      background-color: rgb(223, 49, 49) !important;
    }
  }
  .multiselect__tags-wrap {
    width: max-content;
  }
  .multiselect__option.multiselect__option--group {
    background-color: #e40089 !important;
    color: white !important;
  }
  .placeholder-italic::placeholder {
    font-style: italic !important;
    font-weight: 100;
  }
  .tag-margin {
    margin-bottom: 8px !important;
    margin-right: 8px !important;
  }
  .multiselect__element .multiselect__option {
    font-size: 16px !important;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.88) !important;
  }
  .multiselect__option {
    color: rgba(0, 0, 0, 0.25) !important;
  }

  .multiselect__option:hover > span {
    font-weight: 500;
  }
  .multiselect__element {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.88);
  }
  .multiselect__tags {
    position: relative;
    border: none !important;
    padding: 5.4px 43px 0px 3px;
    @apply appearance-none block w-full border border-gray-300 transition duration-150 ease-in-out rounded;
    &:focus {
      @apply outline-none border-primary;
    }

    .multiselect__single {
      color: black !important;
      text-transform: capitalize;
    }

    input.multiselect__input.focus-visible {
      font-family: Nunito, sans-serif !important;
      padding-left: 0 !important;
      padding-top: 3px !important;
      width: 90% !important;
      @apply text-low;
      @apply bg-primary-color;
    }
  }

  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover,
  .multiselect__element:hover,
  .multiselect__element:active,
  .multiselect__option--highlight {
    background-color: #f2b70580 !important;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.88);
  }
  .multiselect__tags:hover {
  border-color: rgba(168, 174, 184, 0.50) !important;
background: rgba(242, 183, 5, 0.10) !important;
    .multiselect__placeholder{
    color: #717986;
  }
  }
  .multiselect__content-wrapper {
    @apply max-h-full overflow-y-auto flex;
    border: transparent;
    border-radius: 10px;
    margin-top: 12px;
    scrollbar-color: #dedfe6 #f5f5f5 !important;
    scrollbar-width: thin !important;
     box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);

    &::-webkit-scrollbar-track {
      background-color: #f5f5f5 !important;
    }

    &::-webkit-scrollbar {
      width: 4px !important;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #dedfe6 !important;
    }
  }

  .multiselect__input,
  .multiselect__tags,
  .multiselect__single {
    background-color: inherit !important;
  }
  .multiselect__strong {
    border-radius: 93.571px;
    background: rgba(242, 183, 5, 0.15);
    color: #010a11;
    font-weight: 400;
    font-size: 14px;
    padding: 3px 6px;
    margin-right: 17px;
    position: absolute;
    top: 6px;
    right: 26px;
    &:hover {
      border: 1px solid #f2b705;
    }
  }
}

.placeholder-italic {
  background-color: white;
  border-radius: 10px;
  border: 0.5px solid rgba(168, 174, 184, 0.5);
  height: 42px !important;
  width: 100%;
}
</style>

